import script from "./TableRowDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TableRowDialog.vue?vue&type=script&setup=true&lang=js"

import "./TableRowDialog.vue?vue&type=style&index=0&id=6c727882&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c727882"]])

export default __exports__